import request from './request_A'

// 线索团队赠险
// 身份验证页
const verify = (urlParams) => {
    return request({
        url:process.env.VUE_APP_JAHOST+`/backend/url-map-policy/${urlParams.compressionCode}/${urlParams.categoryCode}/${urlParams.level}`,
        params:{
          loading:true, //请求接口时若需展示公共loading 
        },
        method: 'GET',
    }) 
}
// 根据短链压缩码发送短信
const sms = (compressionCode) => {
    return request({
        url:process.env.VUE_APP_JAHOST+`/order/sms/compression-code/${compressionCode}`,
        method: 'POST',
    })
}
// 通过主站机构id集合查询机构信息集合
const merchant_list = (data) => {
    return request({
        url:process.env.VUE_APP_JAHOST+'/backend/institution/getListByInstitutionIds',
        params:{
            loading:true, //请求接口时若需展示公共loading 
            ...data,
          },
          method: 'GET',
    })
}
// 商品方案详情
const scheme_info = (data) => {
    return request({
        url:process.env.VUE_APP_JAHOST+'/backend/commodityScheme/service/list',
        data:{
            loading:true, //请求接口时若需展示公共loading 
            ...data
          },
        method: 'POST',
    })
}

export {
    verify,
    sms,
    merchant_list,
    scheme_info,
}